import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { ISoldInformationsState } from "./slice";
import { getSoldInformationsAsync } from "./actions";

type Reducer = (
  builder: ActionReducerMapBuilder<ISoldInformationsState>
) => void;

export const getSoldInformationsReducer: Reducer = (builder) => {
  builder.addCase(getSoldInformationsAsync.pending, (state) => {
    state.soldInformations.isLoading = true;
  });

  builder.addCase(getSoldInformationsAsync.fulfilled, (state, actions) => {
    state.soldInformations.isLoading = false;
    state.soldInformations.items = actions.payload;
  });

  builder.addCase(getSoldInformationsAsync.rejected, (state) => {
    state.soldInformations.isLoading = false;
    state.soldInformations.items = [];
  });
};
